export const validateUniEmail = (email, university) => {
  const domainList =
    typeof university === "string" ? university : university?.domain;
  const allowedDomains = (domainList || "")
    .split(",")
    .map((domain) => domain.trim().toLowerCase())
    .filter(Boolean);
  const value = (email || "").trim();
  const atIndex = value.indexOf("@");

  if (atIndex <= 0 || atIndex !== value.lastIndexOf("@")) return false;

  const emailDomain = value.slice(atIndex + 1).trim().toLowerCase();
  return allowedDomains.some(
    (domain) =>
      emailDomain === domain || emailDomain.endsWith(`.${domain}`)
  );
};

export const getUniEmailError = (email, university) => {
  if (!email?.trim() || !university) return "";
  if (validateUniEmail(email, university)) return "";

  const domainList =
    typeof university === "string" ? university : university.domain;
  const allowedDomains = (domainList || "")
    .split(",")
    .map((domain) => domain.trim().toLowerCase())
    .filter(Boolean)
    .map((domain) => `@${domain}`);

  return `Please enter a valid university email address matching ${allowedDomains.join(
    " or "
  )}`;
};